import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {WebsiteModuleBrowserSearchEventHandler} from "./website-module.browser-search.event-handler";
import {WebsiteModuleUserSelectionToasterHandler} from "./website-module.user-selection-toaster.handler";
import {UndoClickEventHandler} from "../../../core/handlers/undo.click-event.handler";
import {WebsiteModuleUsPopupHandler} from "./website-module.us-popup.handler";
import {WebsiteWidgetWizardAutoDisplayHandler} from "./website-widget.wizard-auto-display.handler";
import {NotificationSecondNoticeDisplayHandler} from "../../../core/handlers/notification-second-notice.display.handler";
import {WebsiteModuleRouteChangeHandler} from "./website-module.route-change.handler";
import {WebsiteModuleGameContextChangeHandler} from "./website-module.game-context-change.handler";
import {EditButtonClickAnalyticsEventHandler} from "../../../core/handlers/edit-button-click.analytics-event.handler";
import {EditButtonClickHandler} from "../../../core/handlers/edit-button-click.handler";
import {BreadcrumbsClickHandler} from "../../../core/handlers/breadcrumbs-click.handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {GameContextCloseHandler} from "../../../core/handlers/game-context.close.handler";
import {WebsiteModuleFloatingButtonClickHandler} from "./website-module.floating-button-click.handler";
import {WebsiteModuleFloatingButtonClickEventHandler} from "./website-module.floating-button-click.event-handler";
import {WebsiteModuleFloatingButtonDisplayEventHandler} from "./website-module.floating-button-display.event-handler";
import {WebsiteModuleFloatingButtonRemoveEventHandler} from "./website-module.floating-button-remove.event-handler";
import {WebsiteModuleWebToCtaAppHandler} from "./website-module.web-to-cta-app.handler";
import {WebsiteModuleBolaoSettingsFetchHandler} from "./website-module.bolao-settings.fetch-handler";
import {SearchClickHandler} from "../../../core/handlers/search-click.handler";
import {WebsiteModuleDidomiAutoDisplayHandler} from "./website-module.didomi-auto-display.handler";
import {WebsiteModuleMetadataFetchHandler} from "./website-module.metadata.fetch-handler";
import {WebsiteModuleStickyExternalAdDisplayHandler} from "./website-module.sticky-external-ad-display.handler";
import {WebsiteModuleExternalAdDisplayHandler} from "./website-module.external-ad-display.handler";
import {WebsiteModuleAdsAbTestingHandler} from "./website-module.ads-ab-testing.handler";

export class WebsiteModuleHandlers extends HandlerList {

  static injectables = [
    WebsiteModuleBrowserSearchEventHandler,
    WebsiteModuleUsPopupHandler,
    WebsiteModuleUserSelectionToasterHandler,
    WebsiteWidgetWizardAutoDisplayHandler,
    WebsiteModuleRouteChangeHandler,
    WebsiteModuleGameContextChangeHandler,
    WebsiteModuleFloatingButtonClickHandler,
    WebsiteModuleFloatingButtonClickEventHandler,
    WebsiteModuleFloatingButtonDisplayEventHandler,
    WebsiteModuleFloatingButtonRemoveEventHandler,
    WebsiteModuleWebToCtaAppHandler,
    WebsiteModuleBolaoSettingsFetchHandler,
    WebsiteModuleDidomiAutoDisplayHandler,
    WebsiteModuleMetadataFetchHandler,
    WebsiteModuleStickyExternalAdDisplayHandler,
    WebsiteModuleAdsAbTestingHandler,
    WebsiteModuleExternalAdDisplayHandler,
    NotificationSecondNoticeDisplayHandler,
    EditButtonClickAnalyticsEventHandler,
    EditButtonClickHandler,
    BreadcrumbsClickHandler,
    GameContextCloseHandler,
    SearchClickHandler,
    TimingHandler,
    UndoClickEventHandler,
    EntityClickEventHandler
  ];

  constructor(
    websiteModuleBrowserSearchEventHandler: WebsiteModuleBrowserSearchEventHandler,
    websiteModuleUsPopupHandler: WebsiteModuleUsPopupHandler,
    websiteModuleUserSelectionToasterHandler: WebsiteModuleUserSelectionToasterHandler,
    websiteWidgetWizardAutoDisplayHandler: WebsiteWidgetWizardAutoDisplayHandler,
    websiteModuleRouteChangeHandler: WebsiteModuleRouteChangeHandler,
    websiteModuleGameContextChangeHandler: WebsiteModuleGameContextChangeHandler,
    websiteModuleFloatingButtonClickHandler: WebsiteModuleFloatingButtonClickHandler,
    websiteModuleFloatingButtonClickEventHandler: WebsiteModuleFloatingButtonClickEventHandler,
    websiteModuleFloatingButtonDisplayEventHandler: WebsiteModuleFloatingButtonDisplayEventHandler,
    websiteModuleFloatingButtonRemoveEventHandler: WebsiteModuleFloatingButtonRemoveEventHandler,
    websiteModuleWebToCtaAppHandler: WebsiteModuleWebToCtaAppHandler,
    websiteModuleBolaoSettingsFetchHandler: WebsiteModuleBolaoSettingsFetchHandler,
    websiteModuleDidomiAutoDisplayHandler: WebsiteModuleDidomiAutoDisplayHandler,
    websiteModuleMetadataFetchHandler: WebsiteModuleMetadataFetchHandler,
    websiteModuleStickyExternalAdDisplayHandler: WebsiteModuleStickyExternalAdDisplayHandler,
    websiteModuleAdsAbTestingHandler: WebsiteModuleAdsAbTestingHandler,
    websiteModuleExternalAdDisplayHandler: WebsiteModuleExternalAdDisplayHandler,
    notificationSecondNoticeDisplayHandler: NotificationSecondNoticeDisplayHandler,
    editButtonClickAnalyticsEventHandler: EditButtonClickAnalyticsEventHandler,
    editButtonClickHandler: EditButtonClickHandler,
    breadcrumbsClickHandler: BreadcrumbsClickHandler,
    gameContextCloseHandler: GameContextCloseHandler,
    searchClickHandler: SearchClickHandler,
    timingHandler: TimingHandler,
    undoClickEventHandler: UndoClickEventHandler,
    entityClickEventHandler: EntityClickEventHandler
  ) {
    super();

    [
      websiteModuleBrowserSearchEventHandler,
      websiteModuleUsPopupHandler,
      websiteModuleUserSelectionToasterHandler,
      websiteWidgetWizardAutoDisplayHandler,
      websiteModuleRouteChangeHandler,
      websiteModuleGameContextChangeHandler,
      websiteModuleFloatingButtonClickHandler,
      websiteModuleFloatingButtonClickEventHandler,
      websiteModuleFloatingButtonDisplayEventHandler,
      websiteModuleFloatingButtonRemoveEventHandler,
      websiteModuleWebToCtaAppHandler,
      websiteModuleBolaoSettingsFetchHandler,
      websiteModuleDidomiAutoDisplayHandler,
      websiteModuleMetadataFetchHandler,
      websiteModuleStickyExternalAdDisplayHandler,
      websiteModuleAdsAbTestingHandler,
      websiteModuleExternalAdDisplayHandler,
      notificationSecondNoticeDisplayHandler,
      editButtonClickAnalyticsEventHandler,
      editButtonClickHandler,
      breadcrumbsClickHandler,
      gameContextCloseHandler,
      searchClickHandler,
      timingHandler,
      undoClickEventHandler,
      entityClickEventHandler
    ].forEach(handler => this.add(handler));
  }
}
